import React from 'react'

import { Link } from 'react-router-dom';

function Abacus() {

    


    return (
        <>
            <div className="slider1-area overlay-default">
                <div className="bend niceties preview-1">
                    <div id="ensign-nivoslider-3" className="slides">
                        <img src="/images/abacus-img.png" alt="slider" title="#slider-direction-1" />
                        <img src="/images/abacus2.jpg" alt="slider" title="#slider-direction-2" />

                    </div>
                    <div id="slider-direction-1" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-1">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="slider-direction-2" className="t-cn slider-direction">
                        <div className="slider-content s-tb slide-2">
                            <div className="title-container s-tb-c">
                                <div className="slider-btn-area">
                                    <Link to='/contact' target='_blank' className="join-now-btn">Admission Enquiry</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lecturers-page-area">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                            <div className="lecturers-contact-info">
                                <img src="/images/abacus-class.png" className="img-responsive mt-5 pt-5" alt="team" />
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8 col-sm-6 col-xs-12">
                            <h3 className="title-default-left title-bar-big-left-close">About Abacus Courses</h3>
                            <p>An abacus course teaches the fundamentals of using this ancient calculating tool, focusing on both its historical significance and practical applications in arithmetic. The course typically starts with an introduction to the abacus, covering its history and different types, such as the Chinese suanpan and the Japanese soroban. Students learn the anatomy of the abacus, including the beads, rods, and frame, and understand the concept of place values, which is crucial for performing calculations.</p>
                            <p>The initial lessons involve mastering basic arithmetic operations—addition, subtraction, multiplication, and division—through bead movements on the abacus. As students progress, they practice more advanced techniques and shortcuts to handle complex calculations. A significant component of the course is developing mental arithmetic skills by visualizing the abacus in the mind, which enhances cognitive abilities and improves speed and accuracy in calculations.</p>
                            <p>The course is designed for various audiences, including children, students, and adults. For children, it helps develop cognitive skills and a strong number sense, while for students, it enhances mathematical abilities and mental calculation skills. Adults can benefit from the abacus as a hobby or as a method to maintain mental sharpness and memory.</p>
                            <h3 className="title-default-left title-bar-big-left-close">Abacus Course Benefits</h3>
                            <p>The Abacus Course offered by ITT Council is designed to teach students the fundamental techniques of mental arithmetic using the abacus. This course is suitable for beginners as well as those looking to enhance their arithmetic skills. have a look at the benifits: </p>
                            <ul className="course-feature2">
                                <li>Improved Mental Arithmetic</li>
                                <li>Enhanced Cognitive Skills</li>
                                <li>Increased Confidence</li>
                                <li>Lifelong Skill</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Abacus